import { render, staticRenderFns } from "./topModular.vue?vue&type=template&id=7c83d302&scoped=true&"
import script from "./index.ts?vue&type=script&lang=ts&"
export * from "./index.ts?vue&type=script&lang=ts&"
import style0 from "./topModular.vue?vue&type=style&index=0&id=7c83d302&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c83d302",
  null
  
)

export default component.exports